import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, Table, Button, Tag, Tooltip, Typography, Modal, message, Select } from 'antd'

import { req_page_ars_qualifyProjectDivision, req_edit_ars_qualify, req_del_ars_qualify, req_downloadfile_ars_qualify_division, req_list_ars_projectStatus } from '../../api'
import { usrRole } from '../../utils/dataUtil'
import { API_BASE, PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'

import ModifyQualifyModal from './modify-qualify-modal'

const { Text } = Typography;
const { Option } = Select;

class ConfigQualify extends Component {

    state = {
        loading: false,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'None',
        searchValue: '',
        filterStatus: 'NONE',

        domnloadFile: '',
        isShowModifyModal: false,

        division: '日間部',
        reservationIProjectNid: 0,
        projects: []
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_page_items(1)
        this.api_select_options()
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus, reservationIProjectNid, division } = this.state
        const { token, userCode, role } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true })
        const project = reservationIProjectNid
        const result = await req_page_ars_qualifyProjectDivision(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, project, division, token)
        this.setState({ loading: false })

        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    api_edit_item = async (type, applycase) => {
        const token = this.props.user.token
        //this.setState({ loading: true })
        const result = await req_edit_ars_qualify(applycase, token)
        //this.setState({ loading: false })
        if (result.status === 'success') {
            const word = (type === 'CANCEL') ? '取消成功' : '簽領完成'
            message.success(word)
            this.api_page_items(this.current)
        } else {
            message.error(result.message)
        }
    }

    api_del_item = async (key) => {
        const token = this.props.user.token
        //this.setState({ loading: true })
        const result = await req_del_ars_qualify(key, token)
        //this.setState({ loading: false })
        if (result.status === 'success') {
            message.success(result.message)
            this.api_page_items(this.current)
        } else {
            message.error(result.message)
        }
    }

    api_downloadfile_items = async () => {
        const { userLevel, searchField, searchValue, filterStatus, division } = this.state
        const { token, userCode } = this.props.user

        // download file data
        const fileUrl = await req_downloadfile_ars_qualify_division(userCode, userLevel, searchField, searchValue, filterStatus, division, token)

        // download file link      
        let a = document.createElement('a');
        a.href = API_BASE + fileUrl;
        a.target = '_blank'
        a.download = '預約清單';
        a.click();
    }

    api_select_options = async () => {
        const { token } = this.props.user
        const result = await req_list_ars_projectStatus('Y', token)

        //console.log(result)
        if (result.total > 0) {
            const projects = []
            result.data.forEach(item => {
                projects.push({
                    value: item.ReservationIProjectNid,
                    text: item.ReservationIProjectName,
                    disabled: item.ReservationIProjectStatus === 'N' ? true : false
                });
            });
            this.setState({ projects })
            //console.log(projects)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '部別',
                dataIndex: 'Division',
                width: 30,
                responsive: ['md'],
                render: (text, item) => {
                    const { Id, Division } = item
                    let color = this.style_switch_color_tag('Division', Division)
                    return (
                        <Tag color={color} key={Id}>
                            <div>{text}</div>
                        </Tag>
                    )
                }
            },
            {
                title: '獎項名稱',
                dataIndex: 'QualifyDscription',
                width: 45,
                render: (text, item) => {
                    return (
                        <>
                            <Text type="warning"><i className="fas fa-award"></i></Text>{' '}<span> {text}</span>
                        </>
                    )
                }
            },
            {
                title: '學號',
                dataIndex: 'EligibleCode',
                width: 30,
                responsive: ['md'],
            },
            {
                title: '獲獎人',
                dataIndex: 'EligibleName',
                width: 30,
            },
            {
                title: '',
                dataIndex: '',
                width: 30,
                render: (item) => {
                    const { CaseCode } = item
                    return (CaseCode === '0000000000000000') ?
                        (
                            <>
                                <Button type="primary" size='small' onClick={() => this.handle_show_ui_edit(item)} ><i className="fas fa-user-edit"></i><span> 修改</span></Button> {' '}
                                <Button type="primary" size='small' onClick={() => this.handle_show_ui_del(item)} ><i className="fas fa-user-minus"></i><span> 刪除</span></Button>
                            </>
                        ) : ''
                },

            },
        ]
    }

    style_switch_color_tag(column, param) {
        switch (column) {
            case 'EligibleStatus':
                switch (param) {
                    case 'ACCEPT':
                        return 'red'
                    case 'CASEEND':
                        return 'green'
                    default:
                        return 'default';
                }
            case 'Division':
                switch (param) {
                    case '日間部':
                        return 'warning'
                    case '進修部':
                        return 'default'
                    default:
                        return 'default';
                }
            default:
                break;
        }
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {

        this.api_page_items(this.current)
    }

    handle_data_download = () => {
        this.api_downloadfile_items()
    }

    handle_show_ui_add = () => {

    }

    handle_show_ui_edit = (item) => {
        this.setState({ isShowOnSiteModal: true, item })
    }

    handle_show_ui_del = (item) => {
        Modal.confirm({
            title: (<>
                <span>您確定刪除<Text mark>{item.EligibleName}</Text>領取<Text mark>{item.QualifyDscription}</Text>嗎?</span>
            </>),
            onOk: () => {
                this.api_del_item(item.KeyId)
            }
        })
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, item, items, pagination, isShowModifyModal, division, projects, reservationIProjectNid } = this.state
        const options = projects.map(item => <Option key={item.value} value={item.value} disabled={item.disabled}>{item.text}</Option>)

        const title = (
            <span>
                <Select
                    defaultValue={reservationIProjectNid}
                    style={{ width: 150 }}
                    onChange={value => this.setState({ reservationIProjectNid: value })}
                >
                    {options}
                </Select>

                <Select value={division} style={{ width: 90 }} onChange={value => this.setState({ division: value })}>
                    <Select.Option value='日間部'>日間部</Select.Option>
                    <Select.Option value='進修部'>進修部</Select.Option>
                </Select>
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                {' '}
                <Button type='primary' onClick={() => this.handle_data_download()}><i className="fas fa-cloud-download-alt element-hidden"></i> 下載</Button>
                {' '}
                <Button type='primary' onClick={() => this.handle_show_ui_add()}><i className="fas fa-user-plus"></i> 新增</Button>
            </span>
        )
        return (
            <Card title={title} >
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='KeyId'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    title=""
                    visible={isShowModifyModal}
                    width={500}
                    onOk={() => {
                        this.setState({ isShowModifyModal: false })
                        this.api_page_items(this.current)
                    }}
                    onCancel={() => {
                        this.setState({ isShowModifyModal: false })
                    }}
                >
                    <ModifyQualifyModal qualify={item} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ConfigQualify)